module.exports = __webpack_public_path__ + "img/extra-baggage.1533a883.png";